module.exports = __webpack_public_path__ + "img/information-icon3.a9e25581.png";